<template>
  <img
    :src="avatar"
    loading="eager"
    class="avatar"
    :class="size"
    :aria-label="$t('avatar_with_background.avatar_label')"
    alt=""
  />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    avatar: string
    size?: 'xs' | 'sm' | 'md' | 'lg'
  }>(),
  {
    size: 'md'
  }
)
</script>

<style scoped>
.avatar {
  border-radius: theme('borderRadius.full');
  object-fit: cover;
  box-shadow: theme('boxShadow.xl');
  border: 0.125rem solid theme('colors.stone.200');

  .dark & {
    border: 0.125rem solid theme('colors.stone.950');
  }

  &.xs {
    width: 48px;
    height: 48px;
  }

  &.sm {
    width: 50px;
    height: 50px;

    @media (min-width: theme('screens.md')) {
      width: 100px;
      height: 100px;
    }
  }

  &.md {
    width: 100px;
    height: 100px;

    @media (min-width: theme('screens.md')) {
      width: 150px;
      height: 150px;
    }
  }

  &.lg {
    width: 200px;
    height: 200px;

    @media (min-width: theme('screens.md')) {
      width: 300px;
      height: 300px;
    }
  }
}
</style>
